// import { useState, useEffect } from "react";
// import axios from "axios";
// import { BASE_URL, DEFAULT_HEADERS } from "../apiConfig";

// export const useProjectMap = (projectSlug = "sadan") => {
//   const [tiles, setTiles] = useState([]);
//   const [projectData, setProjectData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!projectSlug) return;

//     const fetchProject = async () => {
//       try {
//         setLoading(true);
//         const res = await axios.get(
//           `${BASE_URL}/projects/${projectSlug}`,
//           { headers: DEFAULT_HEADERS }
//         );

//         const data = res.data.data;

//         setTiles(data?.maps || []);
//         setProjectData(data);
//       } catch (err) {
//         console.error("Fetch project map error:", err);
//         setError(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProject();
//   }, [projectSlug]);

//   return {
//     tiles,
//     projectData,
//     loading,
//     error,
//   };
// };
import { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { BASE_URL, DEFAULT_HEADERS } from "../apiConfig";

export const useProjectMap = () => {
  // سحب الـ slug من الـ URL
  const { projectSlug } = useParams();
  
  const [tiles, setTiles] = useState([]);
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // فحص ذكي: لو الـ slug غير موجود أو قيمته نصية "undefined" (بسبب تأخر الـ Router)
    // لا تنفذ الـ Fetch واترك حالة الـ loading كما هي أو تعامل معها
    if (!projectSlug || projectSlug === "undefined") {
      setLoading(true); 
      return;
    }

    const fetchProject = async () => {
      try {
        setLoading(true);
        setError(null); // إعادة تعيين الخطأ عند بدء محاولة جديدة

        console.log(`🔍 API Call: ${BASE_URL}/projects/${projectSlug}`);

        const res = await axios.get(
          `${BASE_URL}/projects/${projectSlug}`,
          { headers: DEFAULT_HEADERS }
        );

        const data = res.data.data;

        if (data) {
          setTiles(data.maps || []);
          setProjectData(data);
          console.log(`✅ Data loaded for project: ${projectSlug}`);
        } else {
          throw new Error("No data received from server");
        }

      } catch (err) {
        console.error(`❌ Fetch Error [${projectSlug}]:`, err.response?.data || err.message);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [projectSlug]); // سيعاد التنفيذ فقط عند تغير الـ slug فعلياً

  return {
    tiles,
    projectData,
    loading: !projectSlug || projectSlug === "undefined" ? true : loading,
    error,
    currentSlug: projectSlug
  };
};